import styled from 'styled-components';
import { XIColors, XIShadowsDown } from '@inmoment/the-kitchen';
const { grey } = XIColors;

export const TopBarWrapper = styled.div`
  box-sizing: border-box;
  height: 66px;
  background: white;
  padding: 18px;
  display: flex;
  align-items: center;
  box-shadow: ${XIShadowsDown[2]};
  z-index: 10;
  position: sticky;
  top: 0;
`;

export const Bar = styled.div`
  height: 42px;
  width: 1px;
  background: ${grey.light[80]};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  width: 264px;
`;
export const Search = styled.div`
  flex: 1;
`;
export const Icons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 12px;
`;

interface VersionNumberProps {
  width: number | string;
}
export const VersionNumber = styled.div`
  padding: 18px 12px;
  width: ${(props: VersionNumberProps) => (typeof props.width === 'number' ? `${props.width}px` : props.width)};
`;
